export default __webpack_public_path__ + "static/media/ico-water.47832278.svg";